<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <slot></slot>
  </div>
</template>

<script>
  import LoadingService from '@/dossier/services/LoadingService';

  const modalStack = [];

  export default {
    mounted() {
      modalStack.unshift(this);

      if ('onClose' in this.$attrs) document.addEventListener('keydown', this.onKeydown);
    },

    beforeUnmount() {
      const i = modalStack.indexOf(this);
      if (i >= 0) modalStack.splice(i, 1);
      document.removeEventListener('keydown', this.onKeydown);
    },

    methods: {
      close() {
        if (!LoadingService.isActive()) this.$emit('close');
      },

      onKeydown(event) {
        if (event.key === 'Escape' && modalStack[0] === this) {
          this.close();
        }
      },
    },
  };
</script>

<style lang="scss">
  .modal {
    z-index: $modal-layer;
  }
</style>
